// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__24vGz","label":"Labeled_label__28Ium","divider":"Labeled_divider__1oSV2"};